import { MatrizForcaMomento, type PontoMatriz } from './MatrizForcaMomento';

// A dispersão força × momento (proto:968-974) precisa de votos do mandato
// por território em dois ciclos eleitorais. Essa série não existe hoje:
// a apuração do TSE (`eleg.resultado_zona`/`eleg.detalhe_zona`) é por zona
// eleitoral, não por bairro, e não há mapeamento zona↔bairro. Por isso a
// lista de pontos fica vazia — ver o motivo detalhado dentro de
// MatrizForcaMomento.tsx — e o componente declara a indisponibilidade em vez
// de plotar números fabricados.
//
// O heatmap território × tema que existia aqui antes (demanda vs. cobertura
// de ações) foi removido: ele tem dado real e funciona, mas a rota promete
// "Matriz de performance" (força × momento, com quadrantes) e entregava outro
// instrumento analítico. Essa visão de demanda/cobertura é útil e merece uma
// rota própria — decisão de produto para depois, fora do escopo desta tarefa.
const PONTOS: PontoMatriz[] = [];

export function MatrizPage() {
  return (
    <div className="page" id="p-matriz">
      <div className="head">
        <div>
          <h1 style={{ color: 'var(--eleg)' }}>Matriz de performance</h1>
          <p>
            Força histórica × momento atual. Prioriza onde investir relacionamento a partir do
            desempenho eleitoral do mandato por território.
          </p>
        </div>
      </div>

      <MatrizForcaMomento pontos={PONTOS} />
    </div>
  );
}
